import {
  AccountsAuditorNoteEntity,
  AccountsAuditorNoteTypeEntity,
  AccountsBalanceSheetEntity,
  AccountsEntity,
  AccountsHighlightsEntity,
  AccountsIncomeStatementEntity,
  AccountsTypeEntity,
  ApiClientEntity,
  ApiClientRoleEntity,
  AppCustomerDetailsEntity,
  AppCustomerEntity,
  AppFeatureEntity,
  AppFeaturePackageCustomerAccessEntity,
  AppFeaturePackageEntity,
  AppFeaturePackageMembershipAssignmentEntity,
  AppInviteTokenEntity,
  AppMembershipEntity,
  AppMembershipRoleEntity,
  AppNotificationDeliveryEntity,
  AppNotificationEntity,
  AppRoleEntity,
  AppSubscriptionEntity,
  AppUserAccountEntity,
  AppUserEntity,
  BranchOfficeEmploymentEntity,
  BranchOfficeEntity,
  BranchOfficeEstablishmentEntity,
  BranchOfficeLocationEntity,
  CompanyAffiliationEntity,
  CompanyAffiliationTypeEntity,
  CompanyCollateralCreditorEntity,
  CompanyCollateralEntity,
  CompanyCollateralTypeEntity,
  CompanyCustomerAttributeEntity,
  CompanyCustomerMeasureEntity,
  CompanyDetailsEntity,
  CompanyEmploymentEntity,
  CompanyEntity,
  CompanyEstablishmentEntity,
  CompanyEventCommonGroupingEntity,
  CompanyEventCommonMeasureEntity,
  CompanyEventCommonModelEntity,
  CompanyEventCommonModelPriorityEntity,
  CompanyEventCommonRuleEntity,
  CompanyEventEntity,
  CompanyFlagEntity,
  CompanyFlagHistoryEntity,
  CompanyFlagTypeEntity,
  CompanyLegalRightCompanyEntity,
  CompanyLegalRightEntity,
  CompanyLegalRightPersonEntity,
  CompanyLocationEntity,
  CompanyLocationTypeEntity,
  CompanyMeasureTypeEntity,
  CompanyMeasureYearlyEntity,
  CompanyNaceCodeEntity,
  CompanyNameEntity,
  CompanyRiskScoreGroupingEntity,
  CompanyRiskScoreMeasureEntity,
  CompanyRiskScoreModelEntity,
  CompanyRiskScoreModelPriorityEntity,
  CompanyRiskScoreOfficialPrioritizedLatestEntity,
  CompanyRoleEntity,
  CompanyRoleOrganizationTypeEntity,
  CompanyShareClassAggregateEntity,
  CompanyShareClassOwnershipEntity,
  CompanyShareOwnershipDirectEntity,
  CompanyShareOwnershipEntity,
  CompanyShareOwnershipIndirectEntity,
  CompanyShareOwnershipUltimateEntity,
  CompanyStateCategoryEntity,
  CompanyStateEntity,
  CompanyStateTimelineEntity,
  DataSourceCategoryEntity,
  DataSourceEntity,
  DigestEntity,
  DigestScheduleCompanyEventTypeGroupFilterEntity,
  DigestScheduleEntity,
  DigestSubscriptionEntity,
  EntityEntity,
  EventEntity,
  GeoCountryEntity,
  GeoGeometryEntity,
  GeoLocationEntity,
  GeoMunicipalityEntity,
  GeoPostalCodeEntity,
  GeoRegionEntity,
  GeoSubdivisionEntity,
  LegalRightEntity,
  ModelTypeEntity,
  NaceCodeEntity,
  OrganizationTypeEntity,
  PersonCompanyRoleEntity,
  PersonEntity,
  PersonFlagEntity,
  PersonFlagTypeEntity,
  PersonMasterEntity,
  ShareClassEntity,
  SimpleSearchEntity,
  UnverifiedEntityEntity,
  WatchlistCompanyRiskScoreMeasureAggregateEntity,
  WatchlistEntity,
} from '../entities/app-base-app';
import {
  MortgagedMovablePropertyNorwayEntity,
  MortgagedMovablePropertyNorwayItemEntity,
  MortgagedMovablePropertyNorwayPartyEntity,
  MortgagedMovablePropertyNorwayPartyTypeEntity,
  MortgagedMovablePropertyNorwayTypeEntity,
} from '../entities/app-base-mortgaged-movable-property';
import {
  CollectionAgencyEntity,
  CollectionCaseActionTypeGroupEntity,
  CollectionCaseActionTypeTimelineEntity,
  CollectionCaseDebtAmountEntity,
  CollectionCaseEntity,
  CollectionCaseLegalActionEntity,
} from '../entities/app-base-payment-remark';
import {
  BuildingEntity,
  BuildingUnitEntity,
  EncumbranceEntity,
  EncumbranceEventEntity,
  EncumbranceEventPartyEntity,
  EncumbranceEventTypeEntity,
  EncumbranceHolderShareEntity,
  EncumbranceTypeEntity,
  PropertyChangeEntity,
  PropertyChangePropertyEntity,
  PropertyEntity,
  PropertyGeoLocationEntity,
  PropertyIdentityNoEntity,
  PropertyPlotEntity,
  PropertyRightEncumbranceEntity,
  PropertyRightEncumbrancePriorityEntity,
  PropertyRightEntity,
  PropertyRightShareEncumbranceEntity,
  PropertyRightShareEntity,
  PropertyRightShareNotationEntity,
  PropertyRightShareTransactionEntity,
  PropertyRightTransactionEntity,
  PropertyRightTypeEntity,
  PropertyTypeEntity,
  RightsholderEntityEncumbranceLienAggregateEntity,
  TransactionAggregateEntity,
  TransactionEntity,
} from '../entities/app-base-property';
import { PartnerReportCustomerAccessEntity, PartnerReportTypeEntity } from '../entities/app-base-report';
import { EncumbranceTypeKey } from '../entities/app-dim-property';
import { BasePayload } from '../types/common';

export interface BaseEntity {
  uuid: string;
  app_url: string;
}

export interface SimpleCollection<T> {
  elements: T[];
  count: number;
  has_more: boolean;
}

export interface SystemStatusEntity {
  message: string;
}

export interface SystemEnvEntity {
  database: 'prod' | 'test' | 'unknown';
  webserver: string | 'unknown';
}

export interface AppIdentityEntity {
  uuid: string;
  app_user_uuid: string;
  app_customer_uuid: string;
  app_customer_slug: string;
  app_user_account_sub: string;
  app_membership_uuid: string;
  app_url: string;
}

export interface AppIdentitySlimCompositeEntity {
  app_user: WithUuid<AppUserEntity>;
  app_customer: WithUuid<AppCustomerEntity>;
  app_customer_details: WithUuid<AppCustomerDetailsEntity>;
  app_membership: WithUuid<AppMembershipEntity>;
}

export interface AppIdentityCompositeEntity extends AppIdentitySlimCompositeEntity {
  app_identity: AppIdentityEntity;
  app_user_account: AppUserAccountEntity;
}

export interface AppMembershipRoleCompositeEntity {
  app_membership_role: AppMembershipRoleEntity;
  app_role: AppRoleEntity;
  app_membership: AppMembershipEntity;
}

export class CompanyRiskScoreAnalysis {
  constructor(
    public model: CompanyRiskScoreModelEntity,
    public measure: CompanyRiskScoreMeasureEntity,
    public grouping: CompanyRiskScoreGroupingEntity,
    public priority: CompanyRiskScoreModelPriorityEntity,
  ) {}
}

export class CompanyEventCommonAnalysis {
  constructor(
    public model: CompanyEventCommonModelEntity,
    public measure: CompanyEventCommonMeasureEntity,
    public grouping?: CompanyEventCommonGroupingEntity,
    public rule?: CompanyEventCommonRuleEntity,
    public priority?: CompanyEventCommonModelPriorityEntity,
    public model_type?: ModelTypeEntity,
  ) {}
}

export interface PartialDigestScheduleComposite {
  digest_schedule: DigestSchedulePartial | DigestScheduleEntity;
  digest_schedule_company_event_type_group_filters: Partial<DigestScheduleCompanyEventTypeGroupFilterEntity>[];
  digest_subscriptions?: Partial<DigestSubscriptionEntity>[];
}

export interface DigestScheduleRequiredFields {
  // These are the required fields that dont have a default.
  uuid?: string;
  watchlist_uuid: string;
  app_customer_uuid: string;
  app_membership_uuid: string;
  company_event_common_grouping_uuid: string;
  schedule_name: string;
  digest_schedule_template_uuid?: string;
  model_type_uuid: string;
  weekly_friday_flag: boolean;
  daily_flag: boolean;
}

export interface DigestSchedulePartial {
  // These are the required fields for posting a new schedule.
  uuid?: string; // used when patching.
  watchlist_uuid: string;
  app_customer_uuid: string;
  app_membership_uuid: string;
  company_event_common_grouping_uuid: string;
  model_type_uuid: string;
  customized_flag: boolean;
  schedule_name: string;
  digest_schedule_template_uuid: string;
  weekly_friday_flag: boolean;
  daily_flag: boolean;
  disabled_flag: boolean;
  auto_send_flag: boolean;
}

export interface DigestScheduleComposite {
  digest_schedule: DigestScheduleEntity;
  digest_schedule_company_event_type_group_filters: DigestScheduleCompanyEventTypeGroupFilterEntity[];
  digest_subscriptions: DigestSubscriptionEntity[];
}

export interface CompanyEventTypeGroupAugmented {
  uuid: string;
  company_event_type_group_key: string;
  parent_company_event_type_group_uuid?: string;
  hierarchy_level: number;
  leaf_flag: boolean;
}

export interface CompanyEventTypeGroupAugmentedTranslated extends CompanyEventTypeGroupAugmented {
  translation: string;
}

export class CompanyEventComposite {
  constructor(
    public company_event: CompanyEventEntity,
    public company: CompanyEntity,
    public data_source_categories: DataSourceCategoryEntity[],
    public event: EventEntity,
    public analyses?: CompanyEventCommonAnalysis[],
  ) {}
}

export class CompanyEventBasicComposite {
  constructor(
    public uuid: string,
    public company_event: CompanyEventEntity,
    public event: EventEntity,
    public company: CompanyEntity,
    public app_url: string,
  ) {}
}

export interface CompanyEventCompositeParams {
  customerUuid?: string;
  companyUuid?: string;
  watchlistUuid?: string;
  limit: string;
  offset: number;
  pageFromTimestamp: Date;
  pageToTimestamp: Date;
  dataSourceUuidList: string[];
  keywordQuery: string;
  modelTypeUuid: string;
  groupKeyList: string[];
  onlyPrioritizedAnalysesFlag: boolean;
}

export interface DataSourceCategoryComposite {
  data_source_category: DataSourceCategoryEntity;
  data_sources: DataSourceEntity[];
}

export class CompanyEventAnalysisComposite {
  constructor(
    public company_event: CompanyEventEntity,
    public company: CompanyEntity,
    public event: EventEntity,
    public analysis: CompanyEventCommonAnalysis,
  ) {}
}

export class CompanyCustomerData {
  constructor(
    public measure: CompanyCustomerMeasureEntity,
    public attribute: CompanyCustomerAttributeEntity,
  ) {}
}

export class CompanyRiskScoreAnalysisListByModel {
  constructor(
    public allAnalyses: {
      [key: string]: CompanyRiskScoreAnalysis[];
    },
    public latestAnalyses: {
      [key: string]: CompanyRiskScoreAnalysis;
    },
    public models: CompanyRiskScoreModelEntity[],
  ) {}
}

export interface CompanyEventAggregate {
  data_source_category_uuid: string;
  data_source_category_key: string;
  event_month: number;
  event_year: number;
  event_count: number;
  event_highlight_composites: EventHighlightComposite[];
}

export interface EventHighlightComposite {
  event: EventEntity;
  company_event_common_grouping: CompanyEventCommonGroupingEntity;
}

export interface IndustryEntity {
  industry_code: string;
  industry_code_description: string;
}

export class PersonCompanyRoleWithCompanyData {
  constructor(
    public personCompanyRole: PersonCompanyRoleEntity,
    public companyRole: CompanyRoleEntity,
    public companyData: CompanyData,
  ) {}
}

export class PersonCompanyRoleCompositeEntity {
  constructor(
    public uuid: string,
    public person: PersonEntity,
    public company: CompanyEntity,
    public company_role: CompanyRoleEntity,
    public person_company_role: PersonCompanyRoleEntity,
    public company_details: CompanyDetailsEntity,
    public company_location: CompanyLocationEntity,
    public company_risk_score_official_prioritized_latest: CompanyRiskScoreOfficialPrioritizedLatestEntity,
    public accounts: AccountsEntity,
    public accounts_highlights: AccountsHighlightsEntity,
    public app_url: string,
  ) {}
}

export class PersonCompanyRolePersonFlagCompositeEntity {
  constructor(
    public uuid: string,
    public person: PersonEntity,
    public company_role: CompanyRoleEntity,
    public person_company_role: PersonCompanyRoleEntity,
    public person_flag_composites: PersonFlagCompositeEntity[],
  ) {}
}

export interface CompanyRoleCompositeEntity {
  uuid: string;
  company_role: CompanyRoleEntity;
  company_role_organization_type: CompanyRoleOrganizationTypeEntity;
  organization_type: OrganizationTypeEntity;
}

export class CompanyData {
  constructor(
    public company: CompanyEntity,
    public companyDetails: CompanyDetailsEntity,
    public accountDataList: AccountsData[],
  ) {}
}

// TODO. deprecate in favor of "AccountsCompositeEntity"
export class AccountsData {
  constructor(
    public accounts: AccountsEntity,
    public accountsHighlights: AccountsHighlightsEntity,
    public accountsIncomeStatement?: AccountsIncomeStatementEntity,
    public accountsBalanceSheet?: AccountsBalanceSheetEntity,
  ) {}
}

export class AccountsAuditorNoteCompositeEntity {
  constructor(
    public accounts: AccountsEntity,
    public accounts_type: AccountsTypeEntity,
    public accounts_auditor_note: AccountsAuditorNoteEntity,
    public accounts_auditor_note_type: AccountsAuditorNoteTypeEntity,
  ) {}
}

export class CompanyAccountsCompositeEntity {
  constructor(
    public accounts: AccountsEntity,
    public accounts_highlights: AccountsHighlightsEntity,
    public accounts_income_statement: AccountsIncomeStatementEntity,
    public accounts_balance_sheet: AccountsBalanceSheetEntity,
    public company: CompanyEntity,
    public accounts_type: AccountsTypeEntity,
  ) {}
}

export class PersonData {
  constructor(
    public person: PersonEntity,
    public personFlagTypeDataList: PersonFlagTypeData[],
    public personMaster: PersonMasterEntity,
  ) {}
}

export interface PersonFlagCompositeEntity {
  /**
   * PersonFlagEntity uuid
   */
  uuid: string;
  person: PersonEntity;
  person_flag: PersonFlagEntity;
  person_flag_type: PersonFlagTypeEntity;
}

export class PersonFlagTypeData {
  constructor(
    public personFlag: PersonFlagEntity,
    public personFlagType: PersonFlagTypeEntity,
  ) {}
}

export class CompanyShareOwnershipData {
  constructor(
    public shareOwnership: CompanyShareOwnershipDirectEntity | CompanyShareOwnershipUltimateEntity,
    public companyData: CompanyData,
    public ownerPersonData: PersonData, // Only ownerPersonData ...
    public ownerCompanyData: CompanyData, // or ownerCompany will have data at one time
  ) {}
}

export interface CompanyEventCompositeEntity extends BaseEntity {
  company_event: CompanyEventEntity;
  event: EventEntity;
  company: CompanyEntity;
}

export interface AppHeartbeatEntity {
  logout_client_flag: boolean;
  refresh_client_flag: boolean;
  refresh_notifications_flag: boolean;
}

export interface SimpleSearchWithDistanceEntity extends SimpleSearchEntity {
  distance: number;
}

export enum SearchQueryMethod {
  quick = 'quick',
  fuzzy = 'fuzzy',
}

export interface CompanyPersonSearchWithDistanceAndSearchType extends SimpleSearchEntity {
  distance: number;
  searchType: SearchQueryMethod;
  itemIndex?: number;
}

export interface CompanyFlagCompositeEntity {
  uuid: string;
  company: CompanyEntity;
  company_flag: CompanyFlagEntity | CompanyFlagHistoryEntity;
  company_flag_type: WithUuid<CompanyFlagTypeEntity>;
  app_url: string;
}

export interface CompanyFlagDashboardCompanyComposite {
  uuid: string;
  company: WithUuid<CompanyEntity>;
  new_company_flag_composites: WithUuid<CompanyFlagCompositeEntity>[];
  current_company_flag_composites: WithUuid<CompanyFlagCompositeEntity>[];
  company_locations: WithUuid<CompanyLocationEntity>[];
  watchlists: WithUuid<WatchlistEntity>[];
}

export interface CompanyFlagTypeAggregate {
  new_company_flag_count: number;
  current_company_flag_count: number;
}

export interface CompanyFlagTypeAggregateComposite {
  uuid: string;
  company_flag_type: WithUuid<CompanyFlagTypeEntity>;
  company_flag_type_aggregate: CompanyFlagTypeAggregate;
}

export class CompanyCollectionEntity {
  constructor(
    public elements: CompanyEntity[],
    public count: number,
    public has_more: boolean,
  ) {}
}

export class AppUserRegistration {
  constructor(
    public app_invite_token_uuid: string,
    public password: string,
    public full_name: string,
  ) {}
}

export class AppCustomerStubEntity {
  constructor(
    public uuid?: string,
    public slug?: string,
    public name?: string,
  ) {}
}

export class CompanyStateTimelineCompositeEntity implements BaseEntity {
  constructor(
    public uuid: string,
    public company_state_timeline: CompanyStateTimelineEntity,
    public company_state: CompanyStateEntity,
    public company_state_category: CompanyStateCategoryEntity,
    public app_url: string,
  ) {}
}

export class CompanyCollateralCreditorCountryAggregateEntity {
  constructor(
    public uuid: string,
    public company_collateral_creditor_uuid: string,
    public company_collateral_type_uuid: string,
    public geo_country_uuid: string,
    public amount: number,
    public collateral_count: number,
    public snapshot_date: Date,
    public insert_timestamp: Date,
    public app_url: string,
  ) {}
}

export class FlagContextEntity {
  constructor(
    public uuid: string,
    public app_translation_key: string,
    public external_url_label: string,
    public external_url: string,
    public entity_uuid: string,
    public entity_key: string,
    public app_feature_uuid: string,
  ) {}
}

export interface CompanyAffiliationCompositeEntity {
  company_affiliation: CompanyAffiliationEntity;
  company_affiliation_type: CompanyAffiliationTypeEntity;
  affiliated_person: PersonEntity;
  affiliated_company: CompanyEntity;
  affiliated_company_location: CompanyLocationEntity;
  affiliated_company_flag_history_composites: CompanyFlagHistoryCompositeEntity[];
  company: CompanyEntity;
  company_location: CompanyLocationEntity;
  company_flag_history_composites: CompanyFlagHistoryCompositeEntity[];
}

export interface AffiliatedEntityCompositeEntity {
  uuid: string;
  affiliated_entity: {
    uuid: string;
    affiliated_entity_uuid: string;
    affiliated_entity_type: string;
    affiliated_entity_name: string;
  };
  affiliated_person: PersonEntity;
  affiliated_company: CompanyEntity;
  company_affiliation_type: CompanyAffiliationTypeEntity;
}

export class CompanyEventDigestCompositeEntity {
  constructor(
    public event: EventEntity,
    public company_event: CompanyEventEntity,
    public analysis: CompanyEventCommonAnalysis,
  ) {}
}

export class CompanyDigestCompositeEntity {
  constructor(
    public company: CompanyEntity,
    public company_risk_score_measure: CompanyRiskScoreMeasureEntity,
    public company_risk_score_model: CompanyRiskScoreModelEntity,
    public company_risk_score_grouping: CompanyRiskScoreGroupingEntity,
    public company_event_composites: CompanyEventDigestCompositeEntity[],
  ) {}
}

export class DigestSectionsEntity {
  constructor(
    public digest_section_title: string,
    public digest_section_context: unknown,
    public digest_section_key: string,
    public company_digest_composites: CompanyDigestCompositeEntity[],
  ) {}
}

export class DigestPyramidEntity {
  constructor(
    public digest: DigestEntity,
    public digest_sections: DigestSectionsEntity[],
    public section_count: number,
    public company_count: number,
    public event_count: number,
  ) {}
}

export interface CompanyFlagHistoryCompositeEntity {
  uuid: string;
  company_flag_history: CompanyFlagHistoryEntity;
  company: CompanyEntity;
  company_flag_type: WithUuid<CompanyFlagTypeEntity>;
}

export interface CompanyFlagHistoryCompositeStubEntity {
  company_flag_history: CompanyFlagHistoryEntity;
  company_flag_type: CompanyFlagTypeEntity;
}

export class AppAccessTokenEntity {
  constructor(
    public id_token: string,
    public access_token: string,
    public scope: string,
    public expires_in: number,
    public token_type: string,
  ) {}
}

export interface AppInviteTokenData {
  user: AppUserEntity;
  customer: AppCustomerEntity;
  membership: AppMembershipEntity;
  appInviteToken: WithUuid<AppInviteTokenEntity>;
}

export class CompanyShareClassOwnershipShallowComposite {
  constructor(
    public company_share_class_ownership: CompanyShareClassOwnershipEntity,
    public company_share_class_aggregate: CompanyShareClassAggregateEntity,
    public share_class: ShareClassEntity,
  ) {}
}

export interface CompanyShareClassAggregateCompositeEntity {
  uuid: string;
  company_share_class_aggregate: CompanyShareClassAggregateEntity;
  company: CompanyEntity;
  share_class: ShareClassEntity;
  app_url: string;
}

interface CompanyShareOwnershipFlagComposite {
  share_issuer_company_flag_history_composites: CompanyFlagHistoryCompositeEntity[] | null;
  shareholder_company_flag_history_composites: CompanyFlagHistoryCompositeEntity[] | null;
  shareholder_person_flag_composites: PersonFlagCompositeEntity[] | null;
}

export interface CompanyShareOwnershipUltimateCompositeEntity extends CompanyShareOwnershipFlagComposite {
  uuid: string;
  company_share_ownership_ultimate: CompanyShareOwnershipEntity;
  company: CompanyEntity; // TODO: Deprecate in favor of share_issuer_company
  shareholder_person: PersonEntity;
  shareholder_company: CompanyEntity;
  rightsholder_person: PersonEntity;
  rightsholder_company: CompanyEntity;
}

export interface CompanyLegalRightPersonComposite {
  person: PersonEntity;
  company_legal_right_person: CompanyLegalRightPersonEntity;
}

export interface CompanyLegalRightCompanyComposite {
  company: CompanyEntity;
  company_legal_right_company: CompanyLegalRightCompanyEntity;
}

export interface CompanyLegalRightCompositeEntity {
  uuid: string;
  company_legal_right: CompanyLegalRightEntity;
  company: CompanyEntity;
  legal_right: LegalRightEntity;
  company_legal_right_person_composites: CompanyLegalRightPersonComposite[];
  company_legal_right_company_composites: CompanyLegalRightCompanyComposite[];
  app_url: string;
}

export interface CompanyShareholderParams {
  year?: number;
  limit?: number;
  shareIssuerCompanyIdentifier?: string;
  shareholderCompanyIdentifier?: string;
  dataSourceKey?: string;
  shareholderPersonUuid?: string;
  shareholderPersonMasterUuid?: string;
  minOwnership?: number;
  offset?: number;
}

export interface CompanyShareOwnershipIndirectCompositeEntity extends CompanyShareOwnershipFlagComposite {
  uuid: string;
  company_share_ownership_indirect: CompanyShareOwnershipEntity;
  company: CompanyEntity; // TODO: Deprecate in favor of share_issuer_company
  shareholder_person: PersonEntity;
  shareholder_company: CompanyEntity;
}

export interface PathOwnershipComposites {
  uuid: string;
  share_issuer_company: CompanyEntity;
  shareholder_person: PersonEntity;
  shareholder_company: CompanyEntity;
  company_share_class_ownership: CompanyShareClassOwnershipEntity;
  company_share_ownership: CompanyShareOwnershipEntity;
}

export interface OwnershipPathsComposite {
  uuid: string;
  calculation_algorithm_key: string;
  ownership_paths: string[][];
  path_ownership_composites: PathOwnershipComposites[][];
  calculation_timestamp: Date;
  app_url: string;
}

export interface CompanyShareOwnershipBeneficialCompositeEntity extends CompanyShareOwnershipFlagComposite {
  uuid: string;
  company_share_ownership_beneficial: CompanyShareOwnershipEntity;
  company: CompanyEntity; // TODO: Deprecate in favor of share_issuer_company
  shareholder_person: PersonEntity;
  shareholder_company: CompanyEntity;
  ownership_paths_composite: OwnershipPathsComposite;
}

export type CompanyAccountsHighlightsCompositeEntity = Pick<
  CompanyAccountsCompositeEntity,
  'accounts' | 'accounts_highlights'
>;

export class CompanyShareOwnershipCompositeEntity {
  constructor(
    public company_share_ownership: CompanyShareOwnershipEntity,
    public share_issuer_company: CompanyEntity | null,
    public shareholder_company: CompanyEntity | null, // parent
    public shareholder_person: PersonEntity | null,
    public share_issuer_company_details: CompanyDetailsEntity | null,
    public shareholder_company_details: CompanyDetailsEntity | null,
    public share_issuer_company_flag_history_composites: CompanyFlagHistoryCompositeEntity[] | null,
    public shareholder_company_flag_history_composites: CompanyFlagHistoryCompositeEntity[] | null,
    public share_issuer_accounts_composite: CompanyAccountsHighlightsCompositeEntity | null,
    public shareholder_accounts_composite: CompanyAccountsHighlightsCompositeEntity | null,
    public share_issuer_company_risk_score_official_prioritized_latest: CompanyRiskScoreOfficialPrioritizedLatestEntity | null,
    public shareholder_company_risk_score_official_prioritized_latest: CompanyRiskScoreOfficialPrioritizedLatestEntity | null,
  ) {}
}

export interface CompanyShareOwnershipDirectCompositeEntity extends CompanyShareOwnershipFlagComposite {
  uuid: string;
  company_share_ownership_direct: CompanyShareOwnershipDirectEntity;
  company_share_class_ownership_shallow_composites: CompanyShareClassOwnershipShallowComposite[];
  company: CompanyEntity; // TODO: Deprecate in favor of share_issuer_company
  shareholder_person: PersonEntity;
  shareholder_company: CompanyEntity;
}

export interface CompanyShareClassOwnershipCompositeEntity extends CompanyShareOwnershipFlagComposite {
  uuid: string;
  company_share_class_ownership: CompanyShareClassOwnershipEntity;
  share_issuer_company: CompanyEntity;
  shareholder_person: PersonEntity;
  shareholder_company: CompanyEntity;
}

export interface UnifiedOwnershipCompositeEntity {
  person: PersonEntity | null;
  company: CompanyEntity | null;
  shareholderName: string | null;
  shareClassGroupKey: string | null;
  shareClassKey: string | null;
  sharePercentByClass: number | null;
  sharePercentByTotal: number | null;
  ownership: number | null;
  votingOwnership: number | null;
  ownershipUpper: number | null;
  ownershipLower: number | null;
  ownershipPathsComposite: OwnershipPathsComposite | null;
  personFlagComposites: PersonFlagCompositeEntity[] | null;
  companyFlagHistoryComposites: CompanyFlagHistoryCompositeEntity[] | null;
  data:
    | CompanyShareOwnershipUltimateEntity
    | CompanyShareOwnershipIndirectEntity
    | CompanyShareOwnershipDirectEntity
    | CompanyShareOwnershipEntity
    | CompanyShareClassOwnershipEntity
    | null;
}

export interface CompanyShareOwnership {
  companyShareOwnership: CompanyShareOwnershipDirectEntity | CompanyShareOwnershipEntity;
  company: CompanyEntity;
  person: PersonEntity;
}

export interface AppFeaturePackageComposite {
  app_feature_entity: AppFeatureEntity[];
  app_feature_package_customer_access_entity: AppFeaturePackageCustomerAccessEntity;
  app_feature_package_entity: AppFeaturePackageEntity;
}

export interface AppFeaturePackageCustomerAccessComposite {
  app_subscription_composite: AppSubscriptionComposite | null;
  app_feature_package_customer_access: AppFeaturePackageCustomerAccessEntity;
  app_feature_package: AppFeaturePackageEntity;
}

export class CompanyRiskScoreCompositeEntity {
  constructor(
    public company_risk_score_measure: CompanyRiskScoreMeasureEntity,
    public company_risk_score_grouping: CompanyRiskScoreGroupingEntity,
    public company_risk_score_model: CompanyRiskScoreModelEntity,
    public company_risk_score_model_priority: CompanyRiskScoreModelPriorityEntity,
    public company: CompanyEntity,
  ) {}
}

export interface ChargebeeHostedPages {
  hosted_page: {
    created_at: number;
    embed: boolean;
    expires_at: number;
    id: string;
    object: string;
    resource_version: number;
    state: string;
    type: string;
    updated_at: number;
    url: string;
  };
}

export interface AppMembershipInviteComposite {
  app_membership: AppMembershipEntity;
  app_feature_package_membership_assignment: AppFeaturePackageMembershipAssignmentEntity;
  app_invite_token: AppInviteTokenEntity;
  app_user: AppUserEntity;
}

export interface AppMembershipInvitePayload {
  app_user_email: string[];
  app_customer_uuid: string;
  app_feature_package_customer_access_uuids: string;
  app_interface_mode_key: string;
}

// TODO: there is also AppFeaturePackageMembershipAssignmentCompositeEntity
export interface AppFeaturePackageMembershipAssignmentComposite {
  app_feature_package_membership_assignment: AppFeaturePackageMembershipAssignmentEntity;
  app_membership: AppMembershipEntity;
  app_feature_package_customer_access: AppFeaturePackageCustomerAccessEntity;
  app_user: AppUserEntity;
  app_membership_role: AppMembershipRoleEntity[];
  app_invite_token: AppInviteTokenEntity;
}

export interface AppSubscriptionComposite {
  uuid: string;
  app_subscription: AppSubscriptionEntity;
  external_context: null;
  app_url: string;
}

export interface Auth0UserVerified {
  email_verified: boolean;
}

export interface AppOnboardPreflightResponse {
  malformed_email_flag: boolean;
  duplicate_email_flag: boolean;
  duplicate_company_flag: boolean;
  secret_uuid_rejected: boolean;
}

export interface FileSessionEntity {
  app_customer_uuid: string;
  file_path: string;
  file_session_uuid: string; // TODO: why is this not uuid?
}

export interface AppMessageOfTheDay {
  uuid: string;
  published_at: string;
  content: {
    html: string;
    emphasis: string;
  };
  customer_slug: string;
  emphasis_icon: string | null;
  dismissible: boolean;
}

export interface AppSurveyEntity {
  uuid: string;
  published_at: string;
  question: string;
  app_survey_key: string;
  start_timestamp: string;
  end_timestamp: string;
}

export interface AccountsStatuses {
  accounts_part_key: string;
  accounts_status_key: string;
}

export interface AccountsStatusComposite {
  accounts: AccountsEntity;
  accounts_statuses: AccountsStatuses[];
}

export interface CompanyNaceCodeCompositesEntity {
  nace_code: NaceCodeEntity;
  company_nace_code: CompanyNaceCodeEntity;
}

export interface CompanyLocationCompositeEntity {
  company_location: CompanyLocationEntity;
  company_location_type: CompanyLocationTypeEntity;
  company: CompanyEntity;
  geo_country: GeoCountryEntity;
  geo_region: GeoRegionEntity;
  geo_subdivision: GeoSubdivisionEntity;
  geo_municipality: GeoMunicipalityEntity;
  geo_postal_code: GeoPostalCodeEntity;
  geo_location: GeoLocationEntity;
}

export interface CompanyLocationDetailsCompositeEntity {
  company_location: CompanyLocationEntity;
  company_location_type: CompanyLocationTypeEntity;
  company: CompanyEntity;
  company_details: CompanyDetailsEntity;
  company_establishment: CompanyEstablishmentEntity;
  geo_location: GeoLocationEntity;
}

export interface SectorMeasureYearlyAggregateEntity {
  lower_percentile: number;
  upper_percentile: number;
  total_count: number;
  not_null_count: number;
  null_count: number;
  average_value: number;
  average_zero_imputed: number;
  median_value: number;
  median_zero_imputed: number;
  min_value: number;
  max_value: number;
  standard_deviation: number;
  standard_deviation_zero_imputed: number;
  highest_company_measure_yearly_composites: CompanyMeasureYearlyCompositeEntity[];
  lowest_company_measure_yearly_composites: CompanyMeasureYearlyCompositeEntity[];
}

export interface CompanyMeasureYearlyBucketEntity {
  bucket_id: number;
  bucket_name: string;
  bucket_lower_bound: number;
  bucket_upper_bound: number;
  company_count: number;
  company_percentage_of_total: number;
  company_percentage_of_not_null: number;
}

export interface CompanyMeasureYearlyCompositeEntity {
  company_measure_yearly: CompanyMeasureYearlyEntity;
  company_measure_type: CompanyMeasureTypeEntity;
  company: CompanyEntity;
}

export interface SectorMeasureYearlyAggregateCompositeEntity {
  sector_measure_yearly_aggregate: SectorMeasureYearlyAggregateEntity;
  company_measure_yearly_buckets: CompanyMeasureYearlyBucketEntity[];
  company_measure_type: CompanyMeasureTypeEntity;
}

export interface CompanyAffiliationCompositeEntity {
  company_affiliation: CompanyAffiliationEntity;
  company_affiliation_type: CompanyAffiliationTypeEntity;
}

export interface CompanyCompositeEntity {
  company: CompanyEntity;
  company_details: CompanyDetailsEntity;
  company_nace_code_composites: CompanyNaceCodeCompositesEntity[];
  company_flag_history_composites: CompanyFlagHistoryCompositeStubEntity[];
  company_location_composite: CompanyLocationCompositeEntity;
  company_employment: CompanyEmploymentEntity[];
  company_names: CompanyNameEntity[];
  person_company_role_composites: PersonCompanyRoleCompositeEntity[];
  company_affiliation_composites: CompanyAffiliationCompositeEntity[];
}

export interface BranchOfficeCompositeEntity {
  uuid: string;
  branch_office: BranchOfficeEntity;
  branch_office_establishment: BranchOfficeEstablishmentEntity;
  branch_office_locations: BranchOfficeLocationEntity[];
  branch_office_employments: BranchOfficeEmploymentEntity[];
}

export interface DataSourceDetailsComposite {
  data_source: DataSourceEntity;
  data_source_details: {
    from_date: Date;
    to_date: Date;
  };
}

export interface PartnerReportCustomerAccessUsageEntity extends PartnerReportCustomerAccessEntity {
  partner_report_order_count: number;
}

export interface PartnerReportAvailabilityEntity {
  available_flag: boolean;
  company_uuid: string | null;
  person_uuid: string | null;
  property_uuid: string | null;
  partner_report_type_uuid: string;
}

export interface PartnerReportAvailabilityCompositeEntity {
  partner_report_availability: PartnerReportAvailabilityEntity;
  company: CompanyEntity | null;
  person: PersonEntity | null;
  property: PropertyEntity | null;
  partner_report_type: PartnerReportTypeEntity;
}

export interface CollectionCaseActionTypeCompositeEntity {
  collection_case_action_type_group: CollectionCaseActionTypeGroupEntity;
  collection_case_action_type_timeline: CollectionCaseActionTypeTimelineEntity;
}

export interface CollectionCaseCompositeEntity {
  uuid: string;
  collection_agency: CollectionAgencyEntity;
  collection_case: CollectionCaseEntity;
  collection_case_debt_amounts: CollectionCaseDebtAmountEntity[];
  collection_case_legal_actions: CollectionCaseLegalActionEntity[];
  collection_case_action_type_composites: CollectionCaseActionTypeCompositeEntity[];
  app_url: string;
}

export interface AppNotificationDeliveryCompositeEntity {
  uuid: string;
  app_notification_delivery: AppNotificationDeliveryEntity;
  app_notification: AppNotificationEntity;
}

// TODO: move this to the watchlist-block after all related components are moved there
export enum WatchlistType {
  Personal = 'personal',
  Shared = 'shared',
  OtherPersonal = 'other_personal',
  Favorite = 'favorite',
}

export interface WatchlistCompositeEntity {
  watchlist: WatchlistEntity;
  digest_schedules: DigestScheduleEntity[];
  digest_subscriptions: DigestSubscriptionEntity[];
  watchlist_company_risk_score_measure_aggregates: WatchlistCompanyRiskScoreMeasureAggregateEntity[];
}

export type AppEntityTimestampKey =
  | 'app.app_icon'
  | 'app.geo_country'
  | 'app.geo_municipality'
  | 'app.geo_postal_code'
  | 'app.geo_subdivision'
  | 'app.nace_code'
  | 'app.gender'
  | 'app.company_collateral_creditor'
  | 'app.company_collateral_type'
  | 'app.company_risk_score_model'
  | 'app.company_risk_score_model_priority'
  | 'app.company_location_type'
  | 'app.company_event_type'
  | 'app.company_flag_type'
  | 'app.data_source';

export type AppEntityTimestampDict = Partial<Record<AppEntityTimestampKey, Date>>;

export type PartialCompanyByUuid = { uuid: string };

type NonRecursiveType = Function | Date | Array<unknown>;

type ShouldRecurse<T> = T extends object ? (T extends NonRecursiveType ? false : true) : false;

type MakeUuidRequired<T> = T extends { uuid?: infer U }
  ? U extends string | undefined
    ? Omit<T, 'uuid'> & { uuid: string }
    : T
  : T;

// Recursive type that makes all optional uuid fields required in nested objects
export type WithUuid<T> =
  ShouldRecurse<T> extends true
    ? MakeUuidRequired<{
        [K in keyof T]: WithUuid<T[K]>;
      }>
    : T;

export enum WatchlistAction {
  PostOneMapping = 'post_one_mapping',
  PostMultipleMappings = 'post_multiple_mappings',
  DeleteOneMapping = 'delete_one_mapping',
  DeleteMultipleMappings = 'delete_multiple_mappings',
  DeleteWatchlist = 'delete_watchlist',
}

interface NkAction<Type extends WatchlistAction, Payload extends { watchlistUuid: string }> {
  type: Type;
  payload: Payload;
}

type PostOneMappingAction = NkAction<WatchlistAction.PostOneMapping, { watchlistUuid: string; companyUuid: string }>;
type PostMultipleMappings = NkAction<WatchlistAction.PostMultipleMappings, { watchlistUuid: string }>;
type DeleteOneMapping = NkAction<WatchlistAction.DeleteOneMapping, { watchlistUuid: string; companyUuid: string }>;
type DeleteMultipleMappings = NkAction<WatchlistAction.DeleteMultipleMappings, { watchlistUuid: string }>;
type DeleteWatchlist = NkAction<WatchlistAction.DeleteWatchlist, { watchlistUuid: string }>;

export type WatchlistChangeAction =
  | PostOneMappingAction
  | PostMultipleMappings
  | DeleteOneMapping
  | DeleteMultipleMappings
  | DeleteWatchlist;

export interface AppPagePrinter {
  file_path: string;
  page_key: string;
  company_identifier: string;
}

export type CompanyReportSection =
  | 'employments'
  | 'risk'
  | 'flags'
  | 'events'
  | 'legal_rights'
  | 'roles'
  | 'ownership'
  | 'collateral'
  | 'mortgaged_movable_property'
  | 'merger_demerger'
  | 'property'
  | 'accounts'
  | 'payment_remarks';

// event_filters is plumbed across two repos. If you rename or add a field here, update:
//   1. nk-app/app-general/enin/commons_web/entities/api_entities/api_app_page_printer.py (schema validation)
//   2. nk-mono/com-page-printer/enin/app_report/page_to_pdf.py (translates payload -> URL query params)
//   3. CompanyReportEventsCardComponent (reads the URL query params on the rendered report)
//   4. CompanyReportOptionsModalComponent (maps EventFeedFilters -> this payload shape)
export interface CompanyReportEventFilters {
  date_from?: string;
  date_to?: string;
  data_source_categories?: string[];
  risk_score_range?: string[];
  model_type_uuid?: string;
}

export interface AppPagePrinterCompanyPayload {
  page_key: 'company_information';
  company_identifier: string;
  report_sections?: CompanyReportSection[];
  event_filters?: CompanyReportEventFilters;
}

export interface AppPagePrinterPropertyPayload {
  page_key: 'property_information';
  property_identifier: string;
}

export interface AppPagePrinterScreeningPayload {
  page_key: 'screening_information';
  screening_config_uuid: string;
  monitoring_origin_entity_uuid: string;
}

export interface AppPagePrinterScreeningCasePayload {
  page_key: 'screening_case_review';
  screening_config_uuid: string;
  screening_entity_uuid: string;
}

export type AppPagePrinterPayload =
  | AppPagePrinterCompanyPayload
  | AppPagePrinterPropertyPayload
  | AppPagePrinterScreeningPayload
  | AppPagePrinterScreeningCasePayload;

export type GeoGeometryPayload = Omit<BasePayload<GeoGeometryEntity>, 'geom'>;

export interface GeoLocationCompositeEntity {
  uuid: string;
  geo_location: GeoLocationEntity;
  geo_subdivision: GeoSubdivisionEntity;
  geo_country: GeoCountryEntity;
  geo_municipality: GeoMunicipalityEntity;
  geo_postal_code: GeoPostalCodeEntity;
  data_source: DataSourceEntity;
}

export interface PropertyRightComposite {
  property_right: PropertyRightEntity;
  property_right_type: PropertyRightTypeEntity;
  property: PropertyEntity;
}

export interface PropertyRightShareCompositeEntity {
  property_right_share: PropertyRightShareEntity;
  property_right: PropertyRightEntity;
  property_right_type: PropertyRightTypeEntity;
  property: PropertyEntity;
  property_type: PropertyTypeEntity;
  rightsholder_company: CompanyEntity | null;
  rightsholder_person: PersonEntity | null;
  rightsholder_unverified_entity: UnverifiedEntityEntity | null;
  rightsholder_property: PropertyEntity | null;
  geo_locations: GeoLocationEntity[] | null;
  property_right_encumbrance_aggregate: PropertyRightEncumbranceAggregate;
}

interface PropertyRightEncumbranceAggregate {
  property_right_uuid: string;
  collateral_exists_flag: boolean;
  collateral_count: number;
  collateral_amount_sum_nok: number;
  encumbrance_exists_flag: boolean;
  encumbrance_count: number;
}

export interface EncumbranceHolderShareCompositeEntity {
  encumbrance_holder_share: EncumbranceHolderShareEntity;
  encumbrance_holder_company: CompanyEntity | null;
  encumbrance_holder_person: PersonEntity | null;
  encumbrance_holder_unverified_entity: UnverifiedEntityEntity | null;
  encumbrance_holder_property_right: PropertyRightEntity;
}

export interface EncumbranceContext {
  amount: number | null;
  currency_code: string | null;
  registered_date: Date | null;
  notification_date: Date | null;
  attached_to_other_encumbrance_key?: string;
  attached_to_other_encumbrance_business_key?: string;
}

export interface EncumberedPropertyAggregateEntity {
  encumbrance_uuid: string;
  encumbered_property_count_non_historic: number;
  encumbered_property_count_historic: number;
}

export interface PropertyRightEncumbranceCompositeEntity {
  property_right_encumbrance: PropertyRightEncumbranceEntity;
  property_right: PropertyRightEntity;
  property_right_type: PropertyRightTypeEntity;
  property: PropertyEntity;
  property_type: PropertyTypeEntity;
  encumbrance: EncumbranceEntityWithContext;
  encumbrance_type: EncumbranceTypeEntity;
  encumbrance_holder_share_composites: EncumbranceHolderShareCompositeEntity[];
  property_right_encumbrance_priority: PropertyRightEncumbrancePriorityEntity; // TODO: this should probably be a list??
  encumbered_property_aggregate: EncumberedPropertyAggregateEntity;
}

export interface EncumbranceEventPartyEncumbranceHolder {
  encumbrance_holder_share: EncumbranceHolderShareEntity;
  encumbrance_holder_company: CompanyEntity;
  encumbrance_holder_person: PersonEntity;
  encumbrance_holder_unverified_entity: UnverifiedEntityEntity;
  encumbrance_holder_property: PropertyEntity;
}

export interface EncumbranceEventPartyPropertyRight {
  property_right: PropertyRightEntity;
  property_right_encumbrance: PropertyRightEncumbranceEntity;
  property_right_share_composites: PropertyRightShareCompositeEntity[];
  encumbrance_event_party: EncumbranceEventPartyEntity;
  property: PropertyEntity;
}
export interface EncumbranceEventPartyPropertyRightShare {
  encumbrance_event_party: EncumbranceEventPartyEntity;
  property: PropertyEntity;
  property_right: PropertyRightEntity;
  property_right_share: PropertyRightShareEntity;
  rightsholder_company: CompanyEntity;
  rightsholder_person: PersonEntity;
  rightsholder_unverified_entity: UnverifiedEntityEntity;
  rightsholder_property: PropertyEntity;
}
export interface EncumbranceEventPartyComposite {
  encumbrance_event_party: EncumbranceEventPartyEntity;
  encumbrance_event_party_encumbrance_holder: EncumbranceEventPartyEncumbranceHolder;
  encumbrance_event_party_property_right_composite: EncumbranceEventPartyPropertyRight;
  encumbrance_event_party_property_right_share_composite: EncumbranceEventPartyPropertyRightShare;
}

export interface EncumbranceEventComposite {
  encumbrance_event: EncumbranceEventEntity;
  encumbrance_event_type: EncumbranceEventTypeEntity;
  encumbrance_event_party_composites: EncumbranceEventPartyComposite[];
}
export interface PropertyRightShareEncumbranceCompositeEntity {
  property_right_share_encumbrance: PropertyRightShareEncumbranceEntity;
  property_right_share: PropertyRightShareEntity;
  encumbrance: EncumbranceEntityWithContext;
  encumbrance_type: EncumbranceTypeEntity;
  property_right: PropertyRightEntity;
  property_right_type: PropertyRightTypeEntity;
  property: PropertyEntity;
  property_type: PropertyTypeEntity;
  rightsholder_company: CompanyEntity | null;
  rightsholder_person: PersonEntity | null;
  rightsholder_unverified_entity: UnverifiedEntityEntity | null;
  rightsholder_property: PropertyEntity | null;
  encumbrance_holder_share_composites: EncumbranceHolderShareCompositeEntity[];
  encumbered_property_aggregate: EncumberedPropertyAggregateEntity;
}

export interface PropertyContext {
  identity: {
    unit_key: {
      value: string;
      local_key: string;
    };
    lease_key: {
      value: string;
      local_key: string;
    };
    section_key: {
      value: string;
      local_key: string;
    };
    cadastral_key: {
      value: string;
      local_key: string;
    };
    municipality_code: {
      value: string;
      local_key: string;
    };
  };
  details?: {
    grunnboka: {
      boligtype_key: string;
      boligtype_name: string;
      brukstype_key: string;
      brukstype_name: string;
    };
    matrikkelen: {
      utgatt: boolean;
      tinglyst: boolean;
      bruksnavn: string;
      punktfeste?: boolean; // is punktfeste. festerett uten eiendomsgrenser.
      er_seksjonert: boolean; //
      etableringsdato: Date;
      har_kulturminne: boolean;
      matrikkelenhet_id: number;
      har_grunnforurensing: boolean;
      har_aktive_festegrunner: boolean;
      grensepunktmerking_mangler: boolean;
      har_avtale_grense_punktfeste: boolean;
      har_avtale_stedbunden_rettighet: boolean;
    };
  };
}

export type PropertyWithContext = Omit<PropertyEntity, 'property_context'> & {
  property_context: PropertyContext | null;
};

export interface PropertyCompositeEntity {
  property: PropertyWithContext;
  property_type: PropertyTypeEntity;
  parent_property: PropertyEntity;
  property_identity_no: PropertyIdentityNoEntity;
  property_right_types: PropertyRightTypeEntity[];
  geo_locations: GeoLocationEntity[];
}

export interface PropertyGeoLocationCompositeEntity {
  uuid: string;
  property_geo_location: PropertyGeoLocationEntity;
  property: PropertyEntity;
  geo_location: GeoLocationEntity;
}

export interface EncumbranceEntityWithContext extends EncumbranceEntity {
  registry_uuid: string;
  encumbrance_key: string;
  encumbrance_type_uuid: string;
  encumbrance_context: EncumbranceContext;
  encumbrance_title: string;
  encumbrance_content: string;
  uuid?: string;
  app_url?: string;
}

export interface PropertySearchCompositeEntity {
  uuid: string;
  property: PropertyEntity;
  property_type: PropertyTypeEntity;
  property_identity_no: PropertyIdentityNoEntity;
  parsed_property_identity_no: Omit<PropertyIdentityNoEntity, 'uuid' | 'app_url'>;
  geo_locations: GeoLocationEntity[];
}

export interface PersonPropertySearchCompositeEntity {
  uuid: string;
  person: PersonEntity;
  simple_search: SimpleSearchEntity;
  rightsholder_entity_encumbrance_lien_aggregate: RightsholderEntityEncumbranceLienAggregateEntity;
}

export interface PropertyOwnersParams {
  propertyUuid: string;
  propertyRightUuid?: string;
}

export class CompanyFlagHistoryAggregateEntity {
  constructor(
    public uuid: string,
    public company_uuid: string,
    public company_flag_type_uuids: string[],
  ) {}
}

export interface CompanyPropertySearchCompositeEntity {
  uuid: string;
  company: CompanyEntity;
  simple_search: SimpleSearchEntity;
  company_flag_history_aggregate: CompanyFlagHistoryAggregateEntity;
  rightsholder_entity_encumbrance_lien_aggregate: RightsholderEntityEncumbranceLienAggregateEntity;
}

export interface EncumbranceCompositeEntity {
  uuid: string;
  encumbrance: EncumbranceEntity;
  encumbrance_type: EncumbranceTypeEntity;
  encumbrance_holder_share_composites: EncumbranceHolderShareCompositeEntity[];
}

export interface PropertyRightEncumbranceBasicComposite {
  property_right_encumbrance: PropertyRightEncumbranceEntity;
  property_right: PropertyRightEntity;
  property: PropertyEntity;
}

export interface PropertyRightEncumbranceBasicComposite {
  property_right_encumbrance: PropertyRightEncumbranceEntity;
  property_right: PropertyRightEntity;
  property: PropertyEntity;
}

export interface PropertyRightShareEncumbranceBasicComposite {
  property_right_share_encumbrance: PropertyRightEncumbranceEntity;
  property_right_share: PropertyRightShareEntity;
  property_right: PropertyRightEntity;
  property: PropertyEntity;
}

export interface EncumbrancePropertyRightShareRightsholderComposite {
  uuid: string;
  encumbrance: EncumbranceEntity;
  encumbrance_type: EncumbranceTypeEntity;
  properties: PropertyEntity[];
  property_right_share_rightsholder: EntityEntity;
  property_right_encumbrance_basic_composites: PropertyRightEncumbranceBasicComposite;
  property_right_share_encumbrance_basic_composites: PropertyRightShareEncumbranceBasicComposite;
}

export interface HousingCooperativePropertyCompositeEntity {
  uuid: string;
  housing_cooperative_property: HousingCooperativePropertyCompositeEntity;
  property: PropertyEntity;
  property_type: PropertyTypeEntity;
  company: CompanyEntity;
}

export interface PropertyChangeCompositeEntity {
  uuid: string;
  property_change: PropertyChangeEntity;
  property_change_property_composites: PropertyChangePropertyCompositeEntity[];
}

export interface PropertyChangePropertyCompositeEntity {
  uuid: string;
  property_change_property: PropertyChangePropertyEntity;
  property_change: PropertyChangeEntity;
  property: PropertyEntity;
}

export const LIEN_ENCUMBRANCE_TYPES: EncumbranceTypeKey[] = [
  EncumbranceTypeKey.lien,
  EncumbranceTypeKey.registered_lien,
  EncumbranceTypeKey.registered_forced_lien,
  EncumbranceTypeKey.enforcement_proceeding,
];

export interface CompanyCollateralComposite {
  company_collateral: CompanyCollateralEntity;
  company_collateral_type: CompanyCollateralTypeEntity;
  company_collateral_creditor: CompanyCollateralCreditorEntity;
  company: CompanyEntity;
}

export interface LabelValueListItem {
  label: string;
  value: string;
  bonusText: string;
  dataCy: string;
}

export interface MortgagedMovablePropertyPartyComposite {
  mortgaged_movable_property_norway_party: MortgagedMovablePropertyNorwayPartyEntity;
  mortgaged_movable_property_norway_party_type: MortgagedMovablePropertyNorwayPartyTypeEntity;
  company?: CompanyEntity;
  person?: PersonEntity;
  unverified_entity?: UnverifiedEntityEntity;
}

export interface MortgagedMovablePropertyComposite {
  uuid: string;
  mortgaged_movable_property_norway: MortgagedMovablePropertyNorwayEntity;
  mortgaged_movable_property_norway_type: MortgagedMovablePropertyNorwayTypeEntity;
  mortgaged_movable_property_items_norway: MortgagedMovablePropertyNorwayItemEntity[];
  mortgaged_movable_property_norway_party_composites: MortgagedMovablePropertyPartyComposite[];
}

export enum DailyWeekly {
  daily = 'daily',
  weekly = 'weekly',
}
export interface PlotContext {
  tvist: boolean;
  avklart_eiere: boolean;
  datafangstdato: Date;
  oppdateringsdato: Date;
  teigarealmerknad_ids: boolean;
  lagret_beregnet_areal: boolean;
  uregistert_jordsameie: false;
  teig_med_flere_matrikkelenheter: boolean;
  has_teigarealmerknad: boolean;
  teigarealmerknad_codes_names: string[];
  teigarealmerknad_code_keys: string[];
  teigarealmerknad_codes: string[];
}

export interface PlotWithComposite {
  uuid: string;
  business_key: string;
  plot_context: PlotContext;
  deleted_flag: boolean;
  app_url?: string;
}

export interface PropertyPlotComposite {
  property: PropertyEntity;
  property_type: PropertyTypeEntity;
  property_plot: PropertyPlotEntity;
  plot: PlotWithComposite;
}

export interface BuildingComposite {
  building: BuildingEntity;
  building_units: BuildingUnitEntity[];
  energy_ratings: EnergyRatingWithCertificate[];
}

export interface BuildingFloor {
  etasjenummer: number | null;
  floor_code_key: string | null;
  floor_code_name: string | null;
  alternativt_areal: number | null;
  bruksareal_totalt: number | null;
  bruttoareal_totalt: number | null;
  alternativt_areal_2: number | null;
  bruksareal_til_annet: number | null;
  bruksareal_til_bolig: number | null;
  bruttoareal_til_annet: number | null;
  bruttoareal_til_bolig: number | null;
  number_of_housing_units: number | null;
}

export interface BuildingHistory {
  status_date?: string | null;
  status_update_timestamp?: string | null; // should be date
  building_status_code_key?: string | null; // should be date
  arsak_til_foring_code_key?: string | null;
  building_status_code_name?: string | null;
  arsak_til_foring_code_name?: string | null;
  status_registered_timestamp?: string | null;
}

// Everything is possibly null since this is a context object.
export interface BuildingContext {
  floors?: BuildingFloor[] | null;
  har_heis?: boolean | null;
  bebygd_areal?: number | null;
  kommunenummer?: string | null;
  bygningsnummer?: number | null;
  avlops_code_key?: string | null; // ?
  har_kulturminne?: boolean | null;
  har_sefrakminne?: boolean | null;
  avlops_code_name?: string | null; // ??
  building_history?: BuildingHistory[] | null;
  skjermingsverdig?: boolean | null;
  uten_bebygd_areal?: boolean | null;
  ufullstendig_areal?: boolean | null;
  building_type_code_key?: string | null;
  naringsgruppe_code_key?: string | null;
  vannforsyning_code_key?: string | null;
  building_type_code_name?: string | null;
  naringsgruppe_code_name?: string | null;
  total_alternativt_areal?: string | null;
  total_bruksareal_totalt?: string | null;
  vannforsyning_code_name?: string | null;
  building_origin_code_key?: string | null;
  building_status_code_key?: string | null;
  total_bruttoareal_totalt?: string | null;
  building_origin_code_name?: string | null;
  building_status_code_name?: string | null;
  total_alternativt_areal_2?: string | null; // Should probably be number...
  total_bruksareal_til_annet?: string | null; // Should probably be number...
  total_bruksareal_til_bolig?: string | null; // Should probably be number...
  total_bruttoareal_til_annet?: string | null; // Should probably be number...
  total_bruttoareal_til_bolig?: string | null; // Should probably be number...
  total_number_of_housing_units?: string | null; // Should probably be number...
}

export interface BuildingWithContext {
  business_key: number;
  building_context: BuildingContext;
  deleted_timestamp: Date | null;
  uuid?: string;
  deleted_flag?: boolean | null;
  app_url?: string;
}

export interface PropertyBuildingAggregateEntity {
  uuid: string;
  property_uuid: string;
  building_count_total: number;
  building_count_shared: number;
  building_count_non_shared: number;
  building_usable_area_total: number;
  building_gross_floor_area_total: number;
  building_unit_count_total: number;
  building_unit_usable_area_total: number;
  building_unit_count_property_connected: number;
  building_unit_usable_area_property_connected: number;
  building_unit_count_non_property_connected: number;
  building_unit_usable_area_non_property_connected: number;
}

export interface BuildingUnitComposite {
  building_unit: BuildingUnitEntity;
  building: BuildingEntity;
  property: PropertyEntity;
}

export interface CollateralAggregate {
  entity_uuid: string;
  count: number;
  sum: number;
  forced_count: number;
  forced_sum: number;
  forced_types: string[];
  voluntary_count: number;
  voluntary_sum: number;
  voluntary_types: string[];
}

export interface TransactionContext {
  har_dokumentavgift: 'true' | 'false';
  vederlag_valutakode: 'NOK';
  data_accuracy_warning: string;
  vederlag_beloepstekst: string;
  vederlag_beloepsverdi: number;
  avgiftsgrunnlag_valutakode: 'NOK';
  dokumentavgift_beloepsverdi: number;
  utlyst_til_salg_paa_det_frie_marked: 'true' | 'false';
  dokument_avgiftsgrunnlag_beloepsverdi: number;
}

export interface PropertyRightShareTransactionCompositeEntity {
  property_right_share_transaction: PropertyRightShareTransactionEntity;
  property_right_share: PropertyRightShareEntity;
  rightsholder_company: CompanyEntity;
  rightsholder_person: PersonEntity;
  rightsholder_unverified_entity: UnverifiedEntityEntity;
  rightsholder_property: PropertyEntity;
}

export interface PropertyRightTransactionComposite {
  property_right_transaction: PropertyRightTransactionEntity;
  property_right: PropertyRightEntity;
  property: PropertyWithContext;
  transaction: TransactionEntity;
  transaction_aggregate: TransactionAggregateEntity;
  property_right_share_transaction_composites: PropertyRightShareTransactionCompositeEntity[];
}

export interface PropertyRightShareNotationComposite {
  property_right_share_notation: PropertyRightShareNotationEntity;
  property_right_share: PropertyRightShareEntity;
  property_right: PropertyRightEntity;
  property: PropertyWithContext;
  rightsholder_company: CompanyEntity | null;
  rightsholder_person: PersonEntity | null;
  rightsholder_unverified_entity: UnverifiedEntityEntity | null;
  rightsholder_property: PropertyEntity | null;
}

export interface PropertyRightShareNotationComposite {
  property_right_share_notation: PropertyRightShareNotationEntity;
  property_right_share: PropertyRightShareEntity;
  property_right: PropertyRightEntity;
  property: PropertyWithContext;
  rightsholder_company: CompanyEntity | null;
  rightsholder_person: PersonEntity | null;
  rightsholder_unverified_entity: UnverifiedEntityEntity | null;
  rightsholder_property: PropertyEntity | null;
}

export interface PropertyTransactionAreaStatisticsConfigEntity {
  uuid: string;
  transaction_uuid: string;
  property_uuid: string;
  geo_geometry_uuid: string;
  radius_in_km: number;
  building_usable_area_min: number;
  building_usable_area_max: number;
  building_type: string;
}

export interface PropertyTransactionAreaStatisticsEntity {
  uuid: string;
  min_growth: number;
  max_growth: number;
  average_growth: number;
  ninetieth_percentile_growth: number;
  upper_quantile_growth: number;
  median_growth: number;
  lower_quantile_growth: number;
  tenth_percentile_growth: number;
  max_comparable_amount: number;
  min_comparable_amount: number;
  average_comparable_amount: number;
  ninetieth_percentile_comparable_amount: number;
  upper_quantile_comparable_amount: number;
  median_comparable_amount: number;
  lower_quantile_comparable_amount: number;
  tenth_percentile_comparable_amount: number;
  transaction_count: number;
  point_in_time: Date;
}

export interface PropertyTransactionAreaStatisticComposite {
  property_transaction_area_statistics_config: PropertyTransactionAreaStatisticsConfigEntity;
  property_transaction_area_statistics: PropertyTransactionAreaStatisticsEntity;
}

export interface CompanyCreditAnalysisEntity {
  uuid: string;
  company_uuid: string;
  calculated_credit_limit: number;
  calculated_credit_limit_timestamp: Date | null;
  adjusted_credit_limit: number;
  adjusted_credit_limit_timestamp: Date | null;
  output_credit_limit: number;
  output_credit_limit_timestamp: Date;
  dangerous_flag: boolean;
  governmental_flag: boolean;
  non_limited_liability_flag: boolean;
  share_of_operating_revenue: number;
  share_of_ebitda: number;
  share_of_total_working_capital: number;
  multiplier_from_risk_level: number;
  minimum_credit_limit: number;
  minimum_credit_limit_when_credit_worthy: number;
  maximum_credit_limit: number;
  input_context: unknown | null;
  input_existing_credit_limit: number | null;
  input_overridden_credit_limit: number | null;
  input_overridden_credit_limit_decision_maker: string | null;
  input_overridden_credit_limit_date: Date | null;
  input_overridden_credit_limit_comment: string | null;
}

export interface CollateralCompilationAggregate {
  entity_uuid: string;
  total_count: number;
  total_sum: number;
  total_forced_count: number;
  total_forced_sum: number;
  total_voluntary_count: number;
  total_voluntary_sum: number;
}

export interface CollateralCompilationAggregateComposite {
  collateral_compilation_aggregate: CollateralCompilationAggregate;
  mortgaged_movable_property_aggregate: CollateralAggregate;
  property_right_share_encumbrance_aggregate: CollateralAggregate;
  property_right_encumbrance_aggregate: CollateralAggregate;
}

export interface NetworkRiskScoreSource {
  entity_key: string;
  entity_name: string;
  entity_uuid: string;
  entity_contributing_score: number;
}

export interface NetworkRiskScore {
  entity_uuid: string;
  entity_key: string;
  entity_name: string;
  network_risk_score: number;
  entity_direct_network_risk_score: number;
  network_risk_sources: NetworkRiskScoreSource[];
}

export interface RelationTypeWeights {
  point: number;
  flag_name: string;
}

export interface AppCustomerNetworkRiskScoreSettingsResultCategory {
  score_range_to: number;
  score_range_from: number;
  result_category_key: string;
  result_category_name: string;
}
export interface AppCustomerNetworkRiskScoreSettings {
  uuid: string;
  app_customer_uuid: string;
  relation_type_weights: RelationTypeWeights;
  relevant_flag_points: unknown; // TODO: company_flags should have a different name
  watchlist_membership_points: unknown;
  result_category: AppCustomerNetworkRiskScoreSettingsResultCategory[];
  included_relation_types: unknown;
}

export interface TokenAuthCredentials {
  token_auth_client_id: string;
  token_auth_client_secret: string;
  api_client_uuid: string;
}

export interface BasicAuthCredentials {
  basic_auth_client_id: string;
  basic_auth_client_secret: string;
  api_client_uuid: string;
}
export interface ApiClientGrants {
  analysis_flag: boolean;
  datasets_flag: boolean;
  token_authentication_flag: boolean;
  api_client_uuid: string;
}

export interface ApiClientComposite {
  api_client: ApiClientEntity;
  token_auth_credentials: TokenAuthCredentials;
  basic_auth_credentials: BasicAuthCredentials;
  api_client_grants: ApiClientGrants;
}

export interface PropertyPlotAggregate {
  plot_count: number;
  total_plot_area: number;
  property_uuid: string;
}

export interface EnergyCertificate {
  byggear: string;
  poststed: string;
  postnummer: string;
  gateadresse: string;
  andelsnummer: string;
  attestnummer: string;
  materialvalg: string;
  bygningsnummer: string;
  energikarakter: string;
  utstedelsesdato: string;
  bygningskategori: string;
  typeregistrering: string;
  bruksenhetsnummer: string;
  harenergivurdering: string;
  beregnetfossilandel: string;
  energivurderingdato: string;
  oppvarmingskarakter: string;
  organisasjonsnummer: string;
  property_matching_rule: string;
  beregnetlevertenergitotaltkwhm2: string;
}
export interface EnergyRatingWithCertificate {
  property_uuid: string;
  building_uuid: string;
  building_unit_uuid: string;
  energy_certificates: EnergyCertificate[] | null;
  uuid?: string;
  app_url?: string;
}

export interface CompanyLifeState {
  states: {
    registered_bankrupt: boolean;
    registered_liquidation: boolean;
    registered_forced_liquidation: boolean;
    confirmed_dead: boolean;
    under_reconstruction: boolean;
  };
  healthy: boolean; // if any of the above is true (bankrupt, liquidated, forcedLiquidation, confirmedDead), this is false.
  mainState: null | CompanyStateTimelineCompositeEntity;
  mainStateKey: null | string;
}

export interface AppCustomerAggregateEntity {
  create_timestamp: Date;
  latest_update_timestamp: Date;
  api_client_count: number;
  app_feature_package_customer_access_count: number;
  app_membership_count: number;
  /**
   * Does not include admins
   */
  main_package_current_seat_count: number;
  /**
   * available_seats from the main package
   */
  main_package_total_seat_count: number;
  main_package_term_end_date: Date | null;
  main_package_grace_end_date: Date | null;
  non_completed_app_invite_token_count: number;
}

// useful to count number of assignments per package
export interface AppFeaturePackageMembershipAssignmentAggregate {
  app_feature_package_assignment_count: number;
  app_feature_package_customer_access_uuid: string;
  app_feature_package_key: string;
  app_membership_uuids: string[];
  app_user_emails: string[];
}

export interface AppMembershipAggregateEntity {
  create_timestamp: Date;
  latest_update_timestamp: Date;
}

export interface AppMembershipRolePayloadEntity {
  app_role_identifier: string;
  app_membership_uuid: string;
}
export interface AppFeaturePackageMembershipAssignmentCompositeEntity {
  app_feature_package_membership_assignment: AppFeaturePackageMembershipAssignmentEntity;
  app_feature_package_customer_access: AppFeaturePackageCustomerAccessEntity;
}

export interface AppMembershipCompositeEntity {
  uuid: string;
  app_membership: AppMembershipEntity;
  app_membership_aggregate: AppMembershipAggregateEntity;
  app_customer: AppCustomerEntity;
  app_user: AppUserEntity;
  app_invite_token: AppInviteTokenEntity;
  app_feature_package_membership_assignment_composites: AppFeaturePackageMembershipAssignmentCompositeEntity[];
  app_membership_roles: AppMembershipRoleEntity[];
}

export interface AppCustomerCompositeEntity {
  uuid: string;
  app_customer: AppCustomerEntity;
  app_customer_details: AppCustomerDetailsEntity;
  app_customer_aggregate: AppCustomerAggregateEntity;
  app_feature_package_customer_accesses: AppFeaturePackageCustomerAccessEntity[];
  app_feature_package_membership_assignment_aggregates: AppFeaturePackageMembershipAssignmentAggregate[];
  api_clients: ApiClientEntity[];
  app_memberships: AppMembershipEntity[];
}

export interface FeaturePackageDataNested {
  appFeaturePackage: AppFeaturePackageEntity;
  appFeatures: AppFeatureEntity[];
}

export type PartialAppCustomer = Pick<AppCustomerEntity, 'name'>;
export type PartialAppFeaturePackageEntity = Pick<AppFeaturePackageEntity, 'app_feature_package_key'>;
export type PartialAppFeaturePackageCustomerAccessComposite = Pick<
  AppFeaturePackageCustomerAccessEntity,
  'available_seats' | 'term_end_date' | 'grace_end_date'
>;
export type PartialAppCustomerDetailsEntity = Pick<
  AppCustomerDetailsEntity,
  'org_nr' | 'org_nr_schema' | 'app_customer_provider_key'
>;

// TODO: rename to AppCustomerPartialCompositeEntity?
export interface PartialAppCustomerCompositeEntity {
  app_customer: PartialAppCustomer;
  app_feature_package: PartialAppFeaturePackageEntity;
  app_feature_package_customer_access: PartialAppFeaturePackageCustomerAccessComposite;
  app_customer_details: PartialAppCustomerDetailsEntity;
}

export type FraudRiskScore = 'very_low' | 'low' | 'medium' | 'high' | 'very_high';

export interface FraudRiskComponentEntity {
  component_key: string;
  component_score: number;
}

export interface CompanyFraudRiskScoreEntity {
  uuid: string;
  company_uuid: string;
  fraud_risk_score: number;
  fraud_risk_level: FraudRiskScore;
  fraud_risk_components: FraudRiskComponentEntity[];
}

export interface ApiClientRoleDetailEntity {
  api_client_role: ApiClientRoleEntity;
  app_role: AppRoleEntity;
}

export interface ApiClientRoleCompositeEntity {
  api_client: ApiClientEntity;
  api_client_role_composites: ApiClientRoleDetailEntity[];
}
